<template>
  <div>
    <v-dialog v-model="openDialog" width="800" @click:outside="close">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          <span v-if="acaoModal === 1">Upload de Arquivos</span>
          <span v-if="acaoModal === 2">Validação de Arquivos</span>
        </v-card-title>

        <v-card-text>
          <v-container text-center>
            <v-row>
              <v-col cols="12">
                <v-chip color="info" class="mb-2 ml-2">
                  {{ value.nome }} - {{ value.periodo }}
                </v-chip>
                <v-chip
                  color="warning"
                  v-if="value.status === 3"
                  class="mb-2 ml-2"
                >
                  Aguardando Validação
                </v-chip>
                <v-chip
                  color="warning"
                  v-if="value.status === 2"
                  class="mb-2 ml-2"
                >
                  Aguardando Arquivos
                </v-chip>
                <v-chip
                  color="success"
                  v-if="value.status === 1"
                  class="mb-2 ml-2"
                >
                  Aprovado
                </v-chip>
                <v-chip
                  color="error"
                  class="mb-2 ml-2"
                  v-if="value.status === 0"
                >
                  Reprovado
                </v-chip>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="6">
                <v-row class="pt-2 pl-3 pb-2"
                  ><span
                    ><strong>Grupo:</strong>&nbsp;{{ value.grupo }}</span
                  ></v-row
                >
                <v-row class="pt-2 pl-3 pb-2"
                  ><span
                    ><strong>Departamento:</strong>&nbsp;{{
                      value.departamento
                    }}</span
                  ></v-row
                >
                <v-row class="pt-2 pl-3 pb-2"
                  ><span
                    ><strong>Empresa:</strong>&nbsp;{{ value.empresa }}</span
                  ></v-row
                >
              </v-col>
              <v-col cols="6">
                <v-row
                  v-for="prop in value.propriedadesEntidade"
                  :key="prop.nome"
                  class="pt-2 pl-3 pb-2"
                >
                  <span
                    ><strong>{{ prop.nome }}:</strong></span
                  >
                  <span class="pl-1">{{ prop.valor }}</span>
                </v-row>
                <!-- <v-row v-if="value.validadeString" class="pt-2 pl-3 pb-2"
                  ><span
                    ><strong>Validade preenchida:</strong>&nbsp;{{
                      montarData(value.validadeString)
                    }}</span
                  ></v-row
                > -->
              </v-col>
            </v-row>

            <v-divider></v-divider>

            <form v-on:submit.prevent="sincronizar" v-if="acaoModal === 1">
              <div v-if="value.tipoDocumento === 4">
                <v-row>
                  <v-col cols="6" offset="3">
                    <v-text-field
                      label="Data de validade"
                      v-model="value.validadeString"
                      type="date"
                      required
                      clearable
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
              </div>
              <v-row text-center>
                <v-col cols="12" text-center>
                  <v-btn color="primary" fab x-small dark @click="novoArquivo"
                    ><v-icon>mdi-plus</v-icon></v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <InputUpload
                  v-for="(arq, indexArq) in value.arquivos"
                  :key="arq.idFront"
                  :index="indexArq"
                  :exibirDelete="indexArq > 0"
                  @clearFile="excluirArquivo(indexArq)"
                  :registro="value"
                  @change="setFiles"
                  @upload="uploadInProgress"
                />
              </v-row>
              <v-divider></v-divider>
              <v-btn
                type="submit"
                :loading="isUploading"
                color="success"
                dark
                text-center
                >Salvar</v-btn
              >
            </form>
            <div v-else>
              <v-row v-if="value.tipoDocumento === 4">
                <v-col cols="6" offset="3">
                  <v-text-field
                    label="Data de validade"
                    v-model="value.validadeString"
                    type="date"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col v-if="value.exclusao === true">
                  <v-alert dense type="error" v-if="anexos.length === 0">
                    Pendência para exclusão
                  </v-alert>
                </v-col>
                <v-col v-else-if="pesquisandoImagens === false">
                  <h5>Anexos</h5>
                  <v-alert dense type="info" v-if="anexos.length === 0">
                    Sem anexos para aprovar
                  </v-alert>
                  <p v-for="anexo in anexos" :key="anexo.id" v-else>
                    <v-btn @click="exibirPDF(anexo)" color="primary">
                      <v-icon class="mr-2">fas fa-file</v-icon>
                      {{ anexo.nomeArquivoOriginal }}
                    </v-btn>
                  </p>
                </v-col>
                <v-col v-else> Carregando anexos... </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col>
                <v-row v-if="value.status === 3 || value.status === 4">
                  <v-col>
                    <v-textarea
                      label="Observações"
                      rows="1"
                      v-model="arquivoValidacao.observacoes"
                      required="true"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row v-if="value.status === 3 || value.status === 4">
              <v-col cols="6">
                <v-btn color="error" small dark @click="reprovar()"
                  ><v-icon small>fas fa-times</v-icon
                  ><span class="ml-2">Reprovar</span></v-btn
                >
              </v-col>
              <v-col
                ><v-btn color="success" small dark @click="aprovar()"
                  ><v-icon small>fas fa-check</v-icon
                  ><span class="ml-2">Aprovar</span></v-btn
                ></v-col
              >
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <TelaLoading :overlay="loading"></TelaLoading>
    </v-dialog>
    <modal-dialog-visualizacao-pdf
      :visivel="modalPDF"
      :pdfFile="pdfExibir"
      @close="fecharPDF"
    />
    <ModalDialogVisualizacaoImg
      :visivel="modalIMG"
      :imgFile="imgExibir"
      @close="fecharIMG"
    />
  </div>
</template>
<script>
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import "vue-pdf-app/dist/icons/main.css";
import ApiService from "@/common/services/http/api.service";
import ModalDialogVisualizacaoPdf from "../../../../components/Visualisador/ModalDialogVisualizacaoPdf.vue";
import TelaLoading from "@/views/components/TelaLoading.vue";
import ModalDialogVisualizacaoImg from "../../../../components/Visualisador/ModalDialogVisualizacaoImg.vue";

import InputUpload from "../../../../components/input/InputUpload.vue";
const extensoesAccept = {
  1: ".pdf",
  2: ".png, .jpeg, .bmp, .webp",
  3: ".xls, .xlsx",
  4: ".doc, .docx",
  5: ".zip, .rar",
  6: ".dwg, .dxf",
};

export default {
  name: "ModalDialogValidar",
  data() {
    return {
      openDialog: false,
      modalPDF: false,
      pdfExibir: undefined,
      modalIMG: false,
      imgExibir: undefined,
      documento: undefined,
      uploads: [],
      isUploading: false,
    };
  },
  watch: {
    visualizar: function (newDialogHistorico) {
      this.openDialog = newDialogHistorico;
    },
    uploads: function (newUploads) {
      this.isUploading = newUploads.some((a) => a.valor);
    },
  },
  computed: {
    accepts() {
      if (!this.value) return "";
      const aceitas = this.value.extensoesID?.map((e) => extensoesAccept[e]);
      if (!aceitas) return ".png, .jpeg, .jpg, .bmp, .webp, .pdf";

      return aceitas.join(", ");
    },
  },
  props: {
    value: Object,
    visualizar: {
      type: Boolean,
      required: true,
    },
    acaoModal: Number,
    arquivoValidacao: Object,
    cliente: Object,
    pesquisandoImagens: Boolean,
    loading: {
      type: Boolean,
      default: false,
    },
    anexos: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    uploadInProgress(index, valor) {
      const exist = this.uploads.filter((d) => d.index != index);
      this.uploads = [...exist, { index, valor }];
    },

    close() {
      this.$emit("close");
    },
    setFiles(event) {
      const documentoAnexo = { ...this.value };

      documentoAnexo.arquivos[event.index] = {
        ...documentoAnexo.arquivos[event.index],
        ...event,
      };

      this.$emit("input", documentoAnexo);
    },
    verificar(value) {
      value = value.toLowerCase();
      const aceitos = this.accepts.split(",");

      return aceitos.some((a) => value.includes(a.trim()));
    },
    aprovar() {
      let self = this;
      const arquivoValidacao = { ...this.arquivoValidacao };
      if (this.value.tipoDocumento == 4) {
        if (!this.value.validadeString) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Validação",
            text: "Informe a data de validação"
          });
          return;
        }
        arquivoValidacao.dataValidade = this.value.validadeString;
      }
      arquivoValidacao.validado = true;
      Swal.fire({
        title: "Tem certeza que deseja APROVAR esse Documento?",
        text: "Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode APROVAR!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.put("arquivo/validar/", arquivoValidacao).then(
              ({ data }) => {
                resolve(data);
                if (data.success) {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Documento Aprovado com Sucesso!",
                    showConfirmButton: false,
                    timer: 1500,
                  }).then(function () {
                    self.close();
                    self.$emit("limparPendencias");
                    self.$emit("listaPendencias", arquivoValidacao.entidadeID);
                  });
                } else {
                  Swal.fire({
                    position: "center",
                    icon: "error",
                    title:
                      data.errors.length > 0
                        ? data.errors.join(", ")
                        : "Ocorreu um erro inesperado",
                  });
                }
              }
            );
          });
        }
      });
    },
    reprovar() {
      let self = this;
      const arquivoValidacao = { ...this.arquivoValidacao };
      if (this.value.tipoDocumento == 4) {
        if (!this.value.validadeString) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Validação",
            text: "Informe a data de validação"
          });
          return;
        }
        arquivoValidacao.dataValidade = this.value.validadeString;
      }
      arquivoValidacao.validado = false;
      arquivoValidacao.clienteID = this.cliente.id;
      if (arquivoValidacao.observacoes == "") {
        SweetAlert.sweetAlertError([
          "A observação é obrigatória para a reprovação",
        ]);
        return;
      }
      Swal.fire({
        title: "Tem certeza que deseja REPROVAR esse Documento?",
        text: "Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode REPROVAR!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.put("arquivo/validar/", arquivoValidacao).then(
              ({ data }) => {
                if (data.success) {
                  resolve(data);
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Documento Reprovado com Sucesso!",
                    showConfirmButton: false,
                    timer: 1500,
                  }).then(function () {
                    self.$emit("close");
                    self.$emit("limparPendencias");
                    self.$emit("listaPendencias", arquivoValidacao.entidadeID);
                  });
                } else SweetAlert.sweetAlertError(data.errors);
              }
            );
          });
        }
      });
    },
    exibirPDF(pdf) {
      if (!pdf) {
        this.modalPDF = false;
        return;
      }
      if (pdf.extensaoID > 2) {
        window.open(pdf.caminhoVisualizacao, "_blank");
        return;
      }

      this.pdfExibir = pdf;
      this.modalPDF = true;
    },
    exibirIMG(img) {
      if (!img) {
        this.modalPDF = false;
        return;
      }

      this.imgExibir = img;
      this.modalIMG = true;
    },
    excluirArquivo(index) {
      const documentoValidacao = { ...this.value };
      documentoValidacao.arquivos.splice(index, 1);
      this.$emit("input", documentoValidacao);
    },
    novoArquivo() {
      const documentoValidacao = { ...this.value };
      documentoValidacao.arquivos.push({
        idFront: new Date().getTime(),
        nome: "",
        arquivo: {},
      });
      this.$emit("input", documentoValidacao);
    },
    async sincronizar() {
      const documento = { ...this.value };
      this.documento = documento;
      let messageErro = undefined;
      let self = this;
      this.exibirLoading(true);

      let hoje = Date.now();
      let dataAtual = new Date(hoje);
      dataAtual.setHours(0, 0, 0, 0);
      let dataValidade = null;

      if (documento.validadeString) {
        let d = documento.validadeString.split("-");
        let dataVal = new Date(d[0], d[1] - 1, d[2]);
        dataValidade = dataVal;
      }

      if (
        documento.tipoDocumentoID === 4 &&
        (documento.validadeString == null || documento.validadeString == "")
      ) {
        const resposta = await Swal.fire({
          position: "center",
          title: "A data de validade não foi preenchida",
          icon: "warning",
          showConfirmButton: false,
          timer: 1500,
        });
        this.exibirLoading(false);
        if (!resposta.isConfirmed) {
          return;
        }
      } else if (
        documento.tipoDocumentoID !== 4 &&
        documento.validadeString == ""
      )
        documento.validadeString = null;
      const anoPeriodo = Number(
        documento.periodo.split("/")[1].padStart(4, "20")
      );
      const mesPeriodo = Number(documento.periodo.split("/")[0]);
      const dataValidacao = new Date(anoPeriodo, mesPeriodo - 1, 1);

      if (dataValidade != null && dataValidade < dataValidacao) {
        const resposta = await Swal.fire({
          position: "center",
          title: "A data de validade deve ser maior do que a data atual",
          icon: "warning",
          showConfirmButton: false,
          timer: 1500,
        });
        this.exibirLoading(false);
        if (!resposta.isConfirmed) {
          return;
        }
      }

      let erro = false;
      let formData = new FormData();

      formData.append("entidadeID", documento.entidade);
      formData.append("documentoID", documento.id);
      formData.append("grupoID", documento.grupoID);
      formData.append("clienteID", this.cliente.id);
      formData.append("mes", documento.periodo.split("/")[0]);
      formData.append("ano", documento.periodo.split("/")[1]);
      formData.append("dataValidade", documento.validadeString);
      formData.append("registroID", documento.registroID);

      for (let i = 0; i < documento.arquivos.length; i++) {
        const arq = documento.arquivos[i];
        formData.append(`arquivos[${i}].arquivo`, arq.arquivo);
        formData.append(`arquivos[${i}].nomeArquivo`, arq.nomeArquivo);
      }

      if (!erro) {
        try {
          const { data: result } = await ApiService.postFormData(
            "arquivo/upload/",
            formData
          );
          if (!result.success) {
            erro = true;
            if (result?.errors?.[0].includes("maiores")) {
              messageErro = result.errors[0];
            }
          } else {
            documento.registroID = result.data;
          }
        } catch (error) {
          erro = true;
          messageErro =
            "O arquivo deve ser do tipo Imagem ou PDF,cada não pode ser maior que 25 Mb e a soma de todos os arquivos não deve superar 100 Mb";
        }
      }

      this.exibirLoading(true);
      if (!erro) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Arquivos Sincronizados com Sucesso!",
          showConfirmButton: false,
          timer: 1500,
        }).then(function () {
          self.$emit("input", documento);
          self.$emit("close");
          self.$emit(
            "listaPendencias",
            documento.entidade,
            documento.departamentoID
          );
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: messageErro || "Ocorreu um erro interno",
        });
      }
      this.exibirLoading(false);
    },
    exibirLoading(estado) {
      this.$emit("loading", estado);
    },
    montarData(data) {
      let [ano, mes, dia] = data.split("-");

      return `${dia}/${mes}/${ano}`;
    },
    fecharPDF() {
      this.pdfExibir = undefined;
      this.modalPDF = false;
    },
    fecharIMG() {
      this.imgExibir = undefined;
      this.modalIMG = false;
    },
  },
  components: {
    ModalDialogVisualizacaoPdf,
    TelaLoading,
    ModalDialogVisualizacaoImg,
    InputUpload,
  },
};
</script>
